(function () {
  'use strict';

  // Moves the "Bundle & Save" badge onto the first product image on bundle
  // templates. Rendered in the info column by product-bundle-items.liquid, then
  // relocated so it overlays the image itself — anchoring to the gallery wrapper
  // puts it outside the photo, since the wrapper is larger than the media.

  function galleryRoot() {
    return document.querySelector('.product-single__gallery') ||
      document.querySelector('.product-single .product__slideshow') ||
      document.querySelector('.product-single .product__images') ||
      document.querySelector('.product-single .product__media') ||
      document.querySelector('.product-single__media');
  }

  function anchorFor(img) {
    var candidates = [
      '.product-single__media',
      '.product__media',
      '.media',
      '[data-media-id]',
      '.product-single__photo',
      '.product__photo'
    ];

    for (var i = 0; i < candidates.length; i++) {
      var match = img.closest(candidates[i]);
      if (match) return match;
    }

    var parent = img.parentElement;
    while (parent && parent !== document.body) {
      var rect = parent.getBoundingClientRect();
      var imgRect = img.getBoundingClientRect();
      if (rect.width > 0 && Math.abs(rect.width - imgRect.width) < 4 && Math.abs(rect.height - imgRect.height) < 40) {
        return parent;
      }
      parent = parent.parentElement;
    }

    return img.parentElement;
  }

  function place() {
    var badge = document.querySelector('[data-bundle-badge]');
    if (!badge || badge.dataset.placed === 'true') return true;

    var root = galleryRoot();
    if (!root) return false;

    var img = root.querySelector('img');
    if (!img || !img.getBoundingClientRect().width) return false;

    var anchor = anchorFor(img);
    if (!anchor) return false;

    anchor.classList.add('bundle-gallery--badged');
    anchor.insertBefore(badge, anchor.firstChild);

    badge.dataset.placed = 'true';
    badge.hidden = false;
    return true;
  }

  function start() {
    if (place()) return;

    var tries = 0;
    var poll = setInterval(function () {
      if (place() || ++tries > 15) clearInterval(poll);
    }, 200);

    window.addEventListener('load', place);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

